import { CancelledInvoiceConstants } from "../constants/cancelledinvoice.constants";

const CancelledInvoicesReducer = (state, action) => {
  switch (action.type) {
    case CancelledInvoiceConstants.FETCH_CANCELLEDINVOICE_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CancelledInvoiceConstants.FETCH_CANCELLEDINVOICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cancelledInvoices: action.payload.data,
        paging: action.payload.paging,
      };
    case CancelledInvoiceConstants.FETCH_CANCELLEDINVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CancelledInvoiceConstants.CANCELLEDINVOICE_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CancelledInvoiceConstants.CANCELLEDINVOICE_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cancelledInvoiceSearchResults: action.payload,
      };
    case CancelledInvoiceConstants.CANCELLEDINVOICE_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CancelledInvoiceConstants.CANCELLEDINVOICE_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CancelledInvoiceConstants.CANCELLEDINVOICE_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cancelledInvoiceAutoSearchResults: action.payload,
      };
    case CancelledInvoiceConstants.CANCELLEDINVOICE_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CancelledInvoiceConstants.GET_CANCELLEDINVOICE_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CancelledInvoiceConstants.GET_CANCELLEDINVOICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cancelledInvoice: action.payload,
      };
    case CancelledInvoiceConstants.GET_CANCELLEDINVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CancelledInvoiceConstants.DOWNLOAD_CANCELLEDINVOICE_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case CancelledInvoiceConstants.DOWNLOAD_CANCELLEDINVOICE_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case CancelledInvoiceConstants.DOWNLOAD_CANCELLEDINVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };

    default:
      return state;
  }
};

export default CancelledInvoicesReducer;
